<template>
  <transition name="fade" mode="out-in" appear>
    <div class="playback-time-picker-comp">
      <div v-on:click="close()" class="background"></div>
      <div class="main">
        <div class="header">
          <!-- {{dates[selectedDateIndex] + ', ' + hours[selectedHourIndex] + ':' + minutes[selectedMinuteIndex] + getAmPm(selectedHourIndex)}} -->
          <div 
          v-for="(value, index) of tabs"
          v-bind:key="index"
          v-bind:class="{selected: selectedTabIndex === index}"
          v-on:click="selectTab(index)"
          class="tab-btn">
            {{value}}
          </div>
        </div>
        <div class="body">
          <div class="camera-container">

            <!-- time-lapse tab selected -->
            <div 
            v-show="tabs[selectedTabIndex] === 'time-lapse'"
            class="content">
              <div 
              v-show="!thumbnailVideoUrls[selectedDateIndex]"
              class="no-recording-text">No recording</div>
              <video
              v-show="thumbnailVideoUrls[selectedDateIndex]"
              ref="thumbnailVideo"
              webkit-playsinline
              playsinline></video>
              <div 
              v-if="thumbnailVideoUrls[selectedDateIndex]"
              class="control-container">
                <div 
                v-on:click="onClickActionBtnForThumbnailVideo()"
                v-bind:class="{loading: !isThumbnailVideoLoaded}"
                class="play-stop-btn">
                  <div v-if="!isThumbnailVideoLoaded">Loading...</div>
                  <svg 
                  v-else-if="!isThumbnailVideoPaused"
                  fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                    <path d="M0 0h24v24H0z" fill="none"/>
                  </svg>
                  <svg 
                  v-else
                  fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5v14l11-7z"/>
                    <path d="M0 0h24v24H0z" fill="none"/>
                  </svg>
                </div>
                <div
                v-on:click="onClickThumbnailVideoPlaybackRate()"
                class="playback-rate-btn">
                  {{thumbnailVideoPlaybackRates[thumbnailVideoDefaultPlaybackRateIndex] + 'x'}} 
                </div>
              </div>
            </div>

            <!-- video tab selected -->
            <div 
            v-show="tabs[selectedTabIndex] === 'video'"
            class="content">
              <div 
              v-show="!recordingVideoUrls[selectedDateIndex]"
              class="no-recording-text">No recording</div>
              <video
              v-show="recordingVideoUrls[selectedDateIndex]"
              ref="recordingVideo"
              webkit-playsinline
              playsinline></video>
              <div 
              v-if="recordingVideoUrls[selectedDateIndex]"
              class="control-container">
                <div 
                v-on:click="onClickActionBtnForRecordingVideo()"
                v-bind:class="{loading: !isRecordingVideoLoaded}"
                class="play-stop-btn">
                  <div v-if="!isRecordingVideoLoaded">Loading...</div>
                  <svg 
                  v-else-if="!isRecordingVideoPaused"
                  fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                    <path d="M0 0h24v24H0z" fill="none"/>
                  </svg>
                  <svg 
                  v-else
                  fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5v14l11-7z"/>
                    <path d="M0 0h24v24H0z" fill="none"/>
                  </svg>
                </div>
                <div
                v-on:click="onClickRecordingVideoPlaybackRate()"
                class="playback-rate-btn">
                  {{recordingVideoPlaybackRates[recordingVideoDefaultPlaybackRateIndex] + 'x'}} 
                </div>
              </div>
            </div>

          </div>
          <div class="timeline-container">
            <div class="dates-container">
                &nbsp;
              <h-scroll-comp
              v-bind:itemWidth="100"
              v-bind:selectedItem="selectedDateIndex"
              v-bind:totalItems="dates.length">
                <div 
                v-for="(value, index) in dates"
                v-bind:key="value"
                v-on:click="onClickDate(index)"
                v-bind:class="{
                  'selected': index === selectedDateIndex,
                  'has-recording': thumbnailVideoUrls[index]
                }"
                class="date">
                  {{value}}
                </div>
              </h-scroll-comp>
            </div>
            <div class="dates-container">
                &nbsp;
              <h-scroll-comp
              v-bind:itemWidth="100"
              v-bind:selectedItem="selectedHourIndex"
              v-bind:totalItems="hours.length">
                <div 
                v-for="(value, index) in hours"
                v-bind:key="value"
                v-on:click="onClickHour(index)"
                v-bind:class="{selected: index === selectedHourIndex}"
                class="date">
                  {{value + getAmPm(index)}}
                </div>
              </h-scroll-comp>
            </div>
            <div class="dates-container">
                &nbsp;
              <h-scroll-comp
              v-bind:itemWidth="100"
              v-bind:selectedItem="selectedMinuteIndex"
              v-bind:totalItems="minutes.length">
                <div 
                v-for="(value, index) in minutes"
                v-bind:key="value"
                v-on:click="onClickMinute(index)"
                v-bind:class="{selected: index === selectedMinuteIndex}"
                class="date">
                  {{value}}
                </div>
              </h-scroll-comp>
            </div>
          </div>
        </div>
        <div 
        v-on:click="close()"
        class="footer">
          Close
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import HScrollComp from './HScrollComp'

export default {
  name: 'playback-time-picker-comp',
  components: { HScrollComp },
  created: function () {
    this.initializeMockupData()
  },
  beforeDestroy: function () {
    this.pauseThumbnailVideo()
  },
  data () {
    return {
      tabs: ['video', 'time-lapse'],
      selectedTabIndex: 0,
      dates: [],
      hours: [],
      minutes: [],
      recordingVideoUrls: [],
      thumbnailVideoUrls: [],
      selectedDateIndex: null,
      selectedHourIndex: null,
      selectedMinuteIndex: null,
      oneHourInThumbnailVideo: 1 / 30 * 60, // 1min / 30fps * 60mins
      oneMinuteInThumbnailVideo: 1 / 30, // 1min / 30fps
      syncingThumbnailVideoCurrentTimeWithTimeline$i: null,
      syncingRecordingVideoCurrentTimeWithTimeline$i: null,
      isThumbnailVideoPaused: true,
      isThumbnailVideoLoaded: false,
      isRecordingVideoPaused: true,
      isRecordingVideoLoaded: false,
      recordingVideoPlaybackRates: [0.5, 1, 2, 4],
      recordingVideoDefaultPlaybackRateIndex: 0,
      thumbnailVideoPlaybackRates: [0.1, 0.3, 0.5, 1, 2, 4, 8],
      thumbnailVideoDefaultPlaybackRateIndex: 0
    }
  },
  methods: {
    close: function () {
      this.$emit('onClose', null)
    },
    selectTab: function (index) {
      if (this.tabs[index]) {
        this.selectedTabIndex = index
      }
    },
    initializeTheWayRecordingVideoShow: function (src) {
      if (this.$refs.recordingVideo) {
        if (src) {
          this.$refs.recordingVideo.src = src
          this.$refs.recordingVideo.controls = false
          this.setRecordingVideoDefaultPlaybackRate()
          this.isRecordingVideoLoaded = false
          this.$refs.recordingVideo.onloadedmetadata = function () {
            this.onLoadedRecordingVideoMetadata()
          }.bind(this)
          this.$refs.recordingVideo.onpause = function () {
            this.pauseRecordingVideo()
          }.bind(this)
          this.$refs.recordingVideo.load()
        } else {
          this.$refs.recordingVideo.src = ''
        }
      }
    },
    initializeTheWayThumbnailVideoShow: function (src) {
      if (this.$refs.thumbnailVideo) {
        if (src) {
          this.$refs.thumbnailVideo.src = src
          this.$refs.thumbnailVideo.controls = false
          this.setThumbnailVideoDefaultPlaybackRate()
          this.isThumbnailVideoLoaded = false
          this.$refs.thumbnailVideo.onloadedmetadata = function () {
            this.onLoadedThumbnailVideoMetadata()
          }.bind(this)
          this.$refs.thumbnailVideo.onpause = function () {
            this.pauseThumbnailVideo()
          }.bind(this)
          this.$refs.thumbnailVideo.load()
        } else {
          this.$refs.thumbnailVideo.src = ''
        }
      }
    },
    setRecordingVideoDefaultPlaybackRate: function (rate) {
      if (this.$refs.recordingVideo) {
        this.$refs.recordingVideo.defaultPlaybackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex]
        this.$refs.recordingVideo.playbackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex]
      }
    },
    setThumbnailVideoDefaultPlaybackRate: function (rate) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.defaultPlaybackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex]
        this.$refs.thumbnailVideo.playbackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex]
      }
    },
    onLoadedRecordingVideoMetadata: function () {
      this.isRecordingVideoLoaded = true
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        let videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo
        this.updateVideoCurrentTime(videoCurrentTime)
        setTimeout(() => { this.resetTimeIndexes() }, 300)
      }
      if (this.isRecordingVideoPaused) {
        this.pauseRecordingVideo()
      } else {
        this.playRecordingVideo()
      }
    },
    onLoadedThumbnailVideoMetadata: function () {
      this.isThumbnailVideoLoaded = true
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        let videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo
        this.updateVideoCurrentTime(videoCurrentTime)
        setTimeout(() => { this.resetTimeIndexes() }, 300)
      }
      if (this.isThumbnailVideoPaused) {
        this.pauseThumbnailVideo()
      } else {
        this.playThumbnailVideo()
      }
    },
    getAmPm: function (hourIndex) {
      if (hourIndex < 12) return 'AM'
      else return 'PM'
    },
    initializeMockupData: function () {
      this.dates = []
      for (let i = 31; i > 0; i--) {
        this.dates.push('May ' + i)
      }
      this.hours = []
      for (let i = 0; i < 24; i++) {
        this.hours.push(i === 0 ? '12' : i < 12 ? i : i === 12 ? '12' : (i - 12))
      }
      this.minutes = []
      for (let i = 0; i < 60; i++) {
        this.minutes.push(i < 10 ? '0' + i : i + '')
      }
      this.recordingVideoUrls = [
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'
      ]
      this.thumbnailVideoUrls = [
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'
      ]
      this.$nextTick(() => {
        this.selectDate(0)
        this.selectHour(0)
        this.selectMinute(0)
      })
    },
    onClickDate: function (dateIndex) {
      this.selectDate(dateIndex)
    },
    selectDate: function (dateIndex) {
      if (this.selectedDateIndex !== dateIndex) {
        if (this.thumbnailVideoUrls[dateIndex]) {
          this.initializeTheWayThumbnailVideoShow(this.thumbnailVideoUrls[dateIndex])
          this.initializeTheWayRecordingVideoShow(this.recordingVideoUrls[dateIndex])
          this.selectedDateIndex = dateIndex
        } else {
          this.pauseThumbnailVideo()
          this.selectedDateIndex = dateIndex
        }
      }
    },
    onClickHour: function (hourIndex) {
      this.selectHour(hourIndex)
      let videoCurrentTime = hourIndex * this.oneHourInThumbnailVideo + this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo
      this.updateVideoCurrentTime(videoCurrentTime)
      // this.onClickMinute(0)
      setTimeout(() => { this.resetTimeIndexes() }, 300)
    },
    selectHour: function (hourIndex) {
      this.selectedHourIndex = hourIndex
    },
    onClickMinute: function (timeIndex) {
      this.selectMinute(timeIndex)
      let videoCurrentTime = timeIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo
      this.updateVideoCurrentTime(videoCurrentTime)
      setTimeout(() => { this.resetTimeIndexes() }, 300)
    },
    selectMinute: function (timeIndex) {
      this.selectedMinuteIndex = timeIndex
    },
    updateVideoCurrentTime: function (time) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.currentTime = time + 0.001
      }
    },
    onClickActionBtnForRecordingVideo: function () {
      if (this.$refs.recordingVideo) {
        if (this.$refs.recordingVideo.paused) this.playRecordingVideo()
        else this.pauseRecordingVideo()
      }
    },
    onClickActionBtnForThumbnailVideo: function () {
      if (this.$refs.thumbnailVideo) {
        if (this.$refs.thumbnailVideo.paused) this.playThumbnailVideo()
        else this.pauseThumbnailVideo()
      }
    },
    playRecordingVideo: function () {
      if (this.$refs.recordingVideo && this.isRecordingVideoLoaded) {
        this.isRecordingVideoPaused = false
        this.$refs.recordingVideo.play()
        this.startSyncingRecordingVideoCurrentTimeWithTimeline()
      }
    },
    pauseRecordingVideo: function () {
      if (this.$refs.recordingVideo) {
        this.isRecordingVideoPaused = true
        this.$refs.recordingVideo.pause()
        this.stopSyncingRecordingVideoCurrentTimeWithTimeline()
      }
    },
    playThumbnailVideo: function () {
      if (this.$refs.thumbnailVideo && this.isThumbnailVideoLoaded) {
        this.isThumbnailVideoPaused = false
        this.$refs.thumbnailVideo.play()
        this.startSyncingThumbnailVideoCurrentTimeWithTimeline()
      }
    },
    pauseThumbnailVideo: function () {
      if (this.$refs.thumbnailVideo) {
        this.isThumbnailVideoPaused = true
        this.$refs.thumbnailVideo.pause()
        this.stopSyncingThumbnailVideoCurrentTimeWithTimeline()
      }
    },
    startSyncingRecordingVideoCurrentTimeWithTimeline: function () {
      this.stopSyncingRecordingVideoCurrentTimeWithTimeline()
      this.syncingRecordingVideoCurrentTimeWithTimeline$i = setInterval(() => {
        this.resetTimeIndexes()
      }, 300)
    },
    stopSyncingRecordingVideoCurrentTimeWithTimeline: function () {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingRecordingVideoCurrentTimeWithTimeline$i)
        this.resetTimeIndexes()
      }
    },
    startSyncingThumbnailVideoCurrentTimeWithTimeline: function () {
      this.stopSyncingThumbnailVideoCurrentTimeWithTimeline()
      this.syncingThumbnailVideoCurrentTimeWithTimeline$i = setInterval(() => {
        this.resetTimeIndexes()
      }, 300)
    },
    stopSyncingThumbnailVideoCurrentTimeWithTimeline: function () {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingThumbnailVideoCurrentTimeWithTimeline$i)
        this.resetTimeIndexes()
      }
    },
    resetTimeIndexes: function () {
      if (this.$refs.thumbnailVideo) {
        let time = this.$refs.thumbnailVideo.currentTime
        let minuteIndex = Math.floor(time / this.oneMinuteInThumbnailVideo)
        let hourIndex = Math.floor(time / this.oneHourInThumbnailVideo)
        minuteIndex = minuteIndex % this.minutes.length
        hourIndex = hourIndex % this.hours.length
        this.selectMinute(minuteIndex)
        this.selectHour(hourIndex)
      }
    },
    onClickRecordingVideoPlaybackRate: function () {
      let index = this.recordingVideoDefaultPlaybackRateIndex + 1
      if (index >= this.recordingVideoPlaybackRates.length) index = 0
      this.recordingVideoDefaultPlaybackRateIndex = index
      this.setRecordingVideoDefaultPlaybackRate()
    },
    onClickThumbnailVideoPlaybackRate: function () {
      let index = this.thumbnailVideoDefaultPlaybackRateIndex + 1
      if (index >= this.thumbnailVideoPlaybackRates.length) index = 0
      this.thumbnailVideoDefaultPlaybackRateIndex = index
      this.setThumbnailVideoDefaultPlaybackRate()
    }
  }
}
</script>

<style scoped>
.playback-time-picker-comp {
  background-color: rgba(0,0,0,0.8);
  width: 100%;
  height: 100%;
  z-index: 100000;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: flex-start; 
  user-select: none;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: ms-autohiding-scrollbar;
  touch-action: manipulation;
}
.playback-time-picker-comp::-webkit-scrollbar {
  display: none;
} 

.playback-time-picker-comp .background {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
.playback-time-picker-comp .main {
  margin-top: 2vh;
  margin-bottom: 120px;
  z-index: 2;
  position: relative;
  max-width: 480px;
  width: calc(100% - 1em);
  background-color: #000;
  outline: 1px solid #fff;
  touch-action: manipulation;
}

.playback-time-picker-comp .header {
  position: absolute;
  width: 100%;
  height: 4em;
  top: 0;
  left: 0;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  touch-action: manipulation;
}
.playback-time-picker-comp .header .tab-btn {
  text-transform: capitalize;
  color: rgba(255,255,255,0.5);
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color .3s;
}
.playback-time-picker-comp .header .tab-btn:hover {
  color: rgba(255,255,255,0.6);
}
.playback-time-picker-comp .header .tab-btn.selected {
  color: rgba(255,255,255,1);
  font-weight: bold;
}
.playback-time-picker-comp .footer {
  position: absolute;
  width: 100%;
  height: 4em;
  bottom: 0;
  left: 0;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  touch-action: manipulation;
}

.playback-time-picker-comp .body {
  padding: 0;
  background-color: #ccc;
  width: 100%;
  height: calc(100% - 8em);
  margin-top: 4em;
  margin-bottom: 4em;
  touch-action: manipulation;
}

.playback-time-picker-comp .body .camera-container {
  width: 100%;
  position: relative;
  background-color: #222;
  color: #fff;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .camera-container:before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 56.25%;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .camera-container > .content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .camera-container > .content img {
  width: 100%;
  height: 100%;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .camera-container > .content .no-recording-text {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .camera-container > .content video {
  width: 100%;
  height: 100%;
  object-fit: fill;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .camera-container > .content video::-webkit-media-controls {
  display: none;
}
.playback-time-picker-comp .body .camera-container > .content .control-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .camera-container > .content .control-container .playback-rate-btn {
  position: absolute;
  font-size: 14px;
  width: 40px;
  height: 20px;
  border-radius: 4px;
  background-color: hsla(210, 100%, 50%, 0.5);
  top: 0.5em;
  left: 0.5em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.playback-time-picker-comp .body .camera-container > .content .control-container .play-stop-btn {
  width: 50px;
  height: 40px;
  border-radius: 8px;
  background-color: hsla(210, 100%, 50%, 0.5);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.playback-time-picker-comp .body .camera-container > .content .control-container .play-stop-btn.loading {
  background-color: transparent;
  width: 100px;
}
.playback-time-picker-comp .body .camera-container > .content .control-container .play-stop-btn svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.playback-time-picker-comp .body .timeline-container {
  padding: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .timeline-container .dates-container {
  padding: 0;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  height: 4em;
  position: relative;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .timeline-container .dates-container .date {
  padding: 0;
  background-color: #fff;
  width: 100px;
  height: calc(4em - 1px);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(0,0,0,0.2);
  transition: color .3s;
  touch-action: manipulation;
}
.playback-time-picker-comp .body .timeline-container .dates-container .date:hover {
  background-color: hsl(210, 0%, 96%);
}
.playback-time-picker-comp .body .timeline-container .dates-container .date.has-recording {
  color: hsla(210, 50%, 50%, 0.8);
}
.playback-time-picker-comp .body .timeline-container .dates-container .date.selected {
  color: rgba(0,0,0,0.8);
  font-weight: bold;
}
.playback-time-picker-comp .body .timeline-container .dates-container .date.selected.has-recording {
  color: rgba(0,0,0,0.8);
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// PlaybackTimePickerComp.vue?6bf9dd65